<template>
  <div class="slider_area">
    <div
      class="single_slider d-flex align-items-center justify-content-center slider_bg_1"
    >
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-xl-6 col-md-6">
            <div class="illastrator_png">
              <img src="@/assets/images/banner/edu_ilastration.png" alt="" />
            </div>
          </div>
          <div class="col-xl-6 col-md-6">
            <div class="slider_info">
              <h3>
                比奥数更锻炼思维<br />
                比阅读更增长知识
              </h3>
              <a href="#" @click.prevent="goCourseShop" class="boxed_btn"
                >寻找适合你的课程</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const router = useRouter();
    // 跳转课程页面
    const goCourseShop = () => {
      router.push("/courseShop");
    };
    return { goCourseShop };
  },
});
</script>
